import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Img from "../Assets/icons/VELOXLogo.png";
import UserIcon from "../Assets/icons/User.svg";
import { ToastContainer, toast } from 'react-toastify';
import "../Styles/UserProfileHeader.css";

const UserProfileHeader = ({ isAdmin }) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [activeButton, setActiveButton] = useState("");
    const menuRef = useRef(null);
    const iconRef = useRef(null);
    const role = localStorage.getItem('role');

    useEffect(() => {
        setActiveButton(window.location.pathname);
    }, []);

    useEffect(() => {
        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open]);

    const handleToggle = () => setOpen(!open);

    const handleClickOutside = (event) => {
        if (
            menuRef.current &&
            !menuRef.current.contains(event.target) &&
            !iconRef.current.contains(event.target)
        ) {
            setOpen(false);
        }
    };

    const handleNavClick = (path) => {
        setActiveButton(path);
        setOpen(false);
        navigate(path);
    };

    const handleLogout = () => {
        setOpen(false);
        localStorage.removeItem('@user');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('role');
        window.location.replace('/');
    };


    const updatePassword = () => navigate('/update_password');
    const veloxLogs = () => navigate('/velox-logs');

    return (
        <>
            <div className='logo-VELOX'>
                <img src={Img} alt="VELOX Life Safety Inc." className="logo" />

                {/* Buttons next to logo */}
                <div className="header-button-group">
                    <button
                        className={activeButton === '/customer-management' ? 'fancy-button selected' : 'fancy-button'}
                        onClick={() => handleNavClick('/customer-management')}
                    >
                        Customer Management
                    </button>
                    <button
                        className={activeButton === '/user-management' ? 'fancy-button selected' : 'fancy-button'}
                        onClick={() => handleNavClick('/user-management')}
                    >
                        VELOX User Management
                    </button>
                    <button
                        className={activeButton === '/yubikey_dashboard' ? 'fancy-button selected' : 'fancy-button'}
                        onClick={() => handleNavClick('/yubikey_dashboard')}
                    >
                        YubiKey Dashboard
                    </button>
                    {(role == 4 || role == 1) && (<button
                        className={activeButton === '/register-yubikey' ? 'fancy-button selected' : 'fancy-button'}
                        onClick={() => handleNavClick('/register-yubikey')}
                    >
                        Register YubiKey
                    </button>)}
                    {(role == 4 || role == 1) && (<button
                        className={activeButton === '/test-yubikey' ? 'fancy-button selected' : 'fancy-button'}
                        onClick={() => handleNavClick('/test-yubikey')}
                    >
                        Test YubiKey
                    </button>)}
                    {/* {role == 6 && (<button
                        className={activeButton === '/commissioningtool' ? 'fancy-button selected' : 'fancy-button'}
                        onClick={() => handleNavClick('/commissioningtool')}
                    >
                        Commissioning Tool
                    </button>)} */}
                </div>

                <img
                    src={UserIcon}
                    alt="User Profile"
                    className="user-pic"
                    onClick={handleToggle}
                    ref={iconRef}
                />
            </div>

            <hr className='login-breakline' />

            {open && (
                <div className="sub-menu-wrap open-menu" ref={menuRef}>
                    <div className="sub-menu">
                        {role == 1 && (<button type="button" className="sub-menu-link" onClick={() => handleNavClick('/create-user')}>
                            <p>Create VELOX User</p>
                        </button>)}
                        <button type="button" className="sub-menu-link" onClick={() => handleNavClick('/messages')}>
                            <p>Messages</p>
                        </button>
                        <button type="button" className="sub-menu-link" onClick={veloxLogs}>
                            <p>Logs</p>
                        </button>
                        <button type="button" className="sub-menu-link" onClick={updatePassword}>
                            <p>Change Password</p>
                        </button>
                        <button type="button" className="sub-menu-link" onClick={handleLogout}>
                            <p>Log Out</p>
                        </button>
                    </div>
                </div>
            )}
            <ToastContainer />
        </>
    );
};

export default UserProfileHeader;
